import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { getStaticFileURL } from '@/shared/lib/image';
import { useGLTF } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useMemo } from 'react';
import { CAMERA_FOV } from '../constants';
import { ModelBuilder } from '../model-builders/model.builder';

export const useModel = () => {
	const { nodes } = useGLTF(getStaticFileURL('models/model.glb'));
	const { state } = useConfigurator();
	const { size } = useThree();

	const aspect = size.width / size.height;
	const height = 2 * Math.tan((CAMERA_FOV * Math.PI) / 180 / 2);
	const width = height * aspect;

	const modelComponents = useMemo(
		() => new ModelBuilder(state, nodes, width).render(),
		[nodes, state],
	);

	return modelComponents;
};
